import { Directive } from '@angular/core';
import { IfAppCustomerDirective } from './if-app-customer.directive';
import { LocalCustomerModel } from '../../customer/customer.model.decorator';

/**
 * Use this directive to present element only when app is NOT in standalone mode OR user does NOT have loyaltyId
 *
 * ```html
 * <div *ifNotAppCustomer>...</div>
 * ```
 */
@Directive({
    selector: '[ifNotAppCustomer]',
    standalone: true
})
export class IfNotAppCustomerDirective extends IfAppCustomerDirective {
    protected override updateCondition() {
        const isStandalone = this.pwaIntegrationService.isStandalone;
        const customerModel = this.customer.model as LocalCustomerModel;
        const hasLoyaltyId = !!customerModel?.loyaltyId;

        this.ngIf = !(isStandalone && hasLoyaltyId);
    }
}
